import { combineReducers } from 'redux'
import authReducer from 'utils/auth/authReducer'
import commonReducer from 'utils/common/commonReducer'
import groupsReducer from 'utils/groups/groupsReducer'
import advicesReducer from 'utils/advices/advicesReducer'
import lawsReducer from 'utils/laws/lawsReducer'
import documentsReducer from 'utils/documents/documentsReducer'
import actionsReducer from 'utils/actions/actionsReducer'
import notificationsReducer from 'utils/notifications/notificationsReducer'
import legalChangesReducer from 'utils/legalChanges/legalChangesReducer'


const reducer = combineReducers({
  auth: authReducer,
  common: commonReducer,
  groups: groupsReducer,
  advices: advicesReducer,
  laws: lawsReducer,
  documents: documentsReducer,
  actions: actionsReducer,
  notifications: notificationsReducer,
  legalChanges: legalChangesReducer
})

export default reducer
